<template>
  <div class="container">
    <div class="inner-component">
      <slot />
    </div>
    <div
      class="description-container"
      v-bind:class="{ floating: showInfoIcon, double: double }"
      v-if="description"
    >
      <div v-if="showInfoIcon">
        <img src="@/assets/img/1x/0info_icon.png" alt="" />
      </div>
      <div>
        <span class="description" v-html="description" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingTip",
  props: {
    description: String,
    showInfoIcon: Boolean,
    double: Boolean
  }
};
</script>

<style scoped>
.inner-component >>> div {
  margin-bottom: 8px;
}
span.description {
  width: 100%;
  font-family: BentonSansBBVA-Light;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666666;
  white-space: normal;
}

div.description-container {
  display: flex;
  padding-top: 5px;
}

div.description-container div {
  display: inline-block;
  vertical-align: top;
}

div.description-container div > img {
  margin-right: 7px;
}

div.description-container div > span {
  display: block;
}

@media screen and (min-width: 600px) {
  .container {
    position: relative;
  }

  /* Si el tip tiene un ícono, se aplica el floating */
  div.description-container.floating {
    position: absolute;
    left: 100%;
    width: 80%; /* Fallback para los que no soportan vw */
    width: 35vw; /* Ancho del tooltip approx 35% del ancho del viewport */
    top: 0;
    padding-left: 36px;
  }

  div.description-container.floating.double {
    left: 205%;
    left: calc(200% + 36px);
  }
}
</style>
